import styled from 'styled-components'

import {
    Menu,
    Badge,
} from 'antd';

export const StyledMenu = styled(Menu)`
    height: 100vh;

    & .ant-menu-submenu {
        padding-left: 10px;
    }

    & .ant-menu-submenu-selected {
        color: #7c7c7c !important;
        background-color: #ffffff !important;
    }
`;

export const MenuItemContent = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 12px;
    width: 100%;
`;

export const StyledBadge = styled(Badge)`
    margin-left: 10px;
`
